import { Box } from '@ouster/webviz-react-components';

import { useStoreState } from 'src/reducers';

import RecordingLookUpData from '../../components/adminDashboard/RecordingLookUpData';
import RecordingLookUpOverview from '../../components/adminDashboard/RecordingLookUpOverview';
import RecordingLookUpSearch from '../../components/adminDashboard/RecordingLookUpSearch';
import RecordingLookUpSensors from '../../components/adminDashboard/RecordingLookUpSensors';

export default function RecordingLookUp() {
  const { recordingLookupResult } = useStoreState(
    (storeState) => storeState.adminDashboard
  );

  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 5fr"
      gap={4}
      height="100%"
      overflow="hidden"
    >
      <RecordingLookUpSearch />

      <Box rowGap="0.75rem" display="grid" overflow="auto">
        <RecordingLookUpOverview />
        <RecordingLookUpData />
        <RecordingLookUpSensors />
        {!recordingLookupResult && (
          <Box
            border="1px solid"
            borderColor="whiteAlpha.200"
            borderRadius="md"
            bgColor="whiteAlpha.50"
            display="grid"
            gap={6}
            placeContent="center"
            justifyItems="center"
            data-testid="recording-lookup-no-result-box"
          >
            <Box fontSize="2xl" color="gray.300">
              Recording lookup console
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
